module.exports = __webpack_public_path__ + "img/矩形 2945.4fce1882.png";